import React from 'react';
import ReactDOM from 'react-dom';
import {IndexRedirect, Router, Route, browserHistory, withRouter} from 'react-router';
import * as Sentry from '@sentry/browser';
import 'semantic-ui-css/semantic.css';
import CreateSchoolForm from './components/Form/CreateSchoolForm';
import FindSchoolForm from './components/Form/FindSchoolForm';
import SignupForm from './components/Form/SignupForm';
import Activities from './pages/Activities/Activities';
import Hygiene from './pages/Activities/Hygiene';
import Fitness from './pages/Activities/Fitness';
import Food from './pages/Activities/Food';
import Rest from './pages/Activities/Rest';
import Sleep from './pages/Activities/Sleep';
import Sunshine from './pages/Activities/Sunshine';
import Water from './pages/Activities/Water';
import App from './pages/App';
import Dashboard from './pages/Dashboard/Dashboard';
import LoggedInApp from './pages/LoggedInApp';
import LoggedOutApp from './pages/LoggedOutApp';
import ForgotPassword from './pages/Login/ForgotPassword';
import Login from './pages/Login/Login';
import ResetPassword from './pages/Login/ResetPassword';
import Signup from './pages/Login/Signup';
import SchoolSemesters from './pages/Schools/SchoolSemesters';
import SemesterProgress from './pages/Balances/SemesterProgress';
import SchoolUsers from './pages/Schools/SchoolUsers';
import StaffPoints from './pages/Schools/StaffPoints';
import Clock from './pages/Stress/Clock';
import Health from './pages/Stress/Health';
import Money from './pages/Stress/Money';
import People from './pages/Stress/People';
import Personal from './pages/Stress/Personal';
import StressProfile from './pages/Stress/StressProfile';
import UserProfile from './pages/Profile/UserProfile';
import Leaderboard from './pages/Team/Leaderboard';
import StudentPoints from './pages/Schools/StudentPoints';
import {isOwesSubscriptionMoney, isOwesTeamMoney, isAuthenticated} from './util/Session';
import FindTeamForm from './components/Form/FindTeamForm';
import SignupTeamForm from './components/Form/SignupTeamForm';
import TeamDonations from './pages/Team/TeamDonations';
import SubscriptionPayments from './pages/Subscriptions/SubscriptionPayments';

if (process.env.NODE_ENV !== 'development') {
  Sentry.init({
    ignoreErrors: ['Network Error', 'Request failed with status code 401'],
    dsn: 'https://59eb879eb80546be97e65f24b4529475@sentry.io/1359803',
    environment: process.env.NODE_ENV
  });
}

const ConditionalRedirectWrapper = (WrappedComponent, shouldRedirectFn, redirectTo) => {
  const IsAuthenticatedClass = (props) => {
    // eslint-disable-next-line react/prop-types
    const {router} = props;
    if (shouldRedirectFn()) {
      // eslint-disable-next-line react/prop-types
      router.push(redirectTo);
      return null;
    }
    return <WrappedComponent {...props} />;
  };

  return withRouter(IsAuthenticatedClass);
};

ReactDOM.render(
  (
    <Router history={browserHistory}>
      <Route path="/" component={App}>

        {/* Login and Sign-up */}
        <Route component={ConditionalRedirectWrapper(LoggedOutApp, () => isAuthenticated(), '/dashboard')}>
          <IndexRedirect to="login"/>
          <Route path="login" component={Login}/>
          <Route path="forgot-password" component={ForgotPassword}/>
          <Route path="forgot-password/reset" component={ResetPassword}/>
          <Route path="sign-up" component={Signup}>
            {/* Designated administrator - creating school */}
            <Route path="create/schools" component={CreateSchoolForm}/>

            {/* Student - joining school */}
            <Route path="join/schools" component={FindSchoolForm}/>
            <Route path="join/schools/:schoolId" component={SignupForm}/>

            {/* Family & community - joining team */}
            <Route path="join/teams" component={FindTeamForm}/>
            <Route path="join/teams/:teamId" component={SignupTeamForm}/>
          </Route>
        </Route>

        <Route component={ConditionalRedirectWrapper(LoggedInApp, () => !isAuthenticated(), '/login')}>

          {/* Forced payment pages if user owes $ - either for new school signups or family & community signups */}
          <Route path="/team-donations" component={TeamDonations}/>
          <Route path="/subscription-payments" component={SubscriptionPayments}/>
          <Route path="/profile" component={UserProfile}/>

          <Route component={ConditionalRedirectWrapper(LoggedInApp, () => isOwesSubscriptionMoney(), '/subscription-payments')}>
            <Route component={ConditionalRedirectWrapper(LoggedInApp, () => isOwesTeamMoney(), '/team-donations')}>
              <Route path="/dashboard" component={Dashboard}/>
              <Route path="/team" component={Leaderboard}/>
              <Route path="/stress" component={StressProfile}>
                <Route path="people" component={People}/>
                <Route path="money" component={Money}/>
                <Route path="personal" component={Personal}/>
                <Route path="health" component={Health}/>
                <Route path="clock" component={Clock}/>
              </Route>
              <Route path="/activities" component={Activities}>
                <Route path="hygiene" component={Hygiene}/>
                <Route path="food" component={Food}/>
                <Route path="fitness" component={Fitness}/>
                <Route path="rest" component={Rest}/>
                <Route path="sleep" component={Sleep}/>
                <Route path="sunshine" component={Sunshine}/>
                <Route path="water" component={Water}/>
              </Route>
              <Route path="/schools/students" component={StudentPoints}/>
              <Route path="/schools/staff" component={StaffPoints}/>
              <Route path="/schools/users" component={SchoolUsers}/>
              <Route path="/schools/semesters" component={SchoolSemesters}/>
              <Route path="/progress" component={SemesterProgress}/>
            </Route>
          </Route>
        </Route>
      </Route>
    </Router>
  ),
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js